import {UntypedFormGroup} from '@angular/forms';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getObjectValues'
})
export class GetObjectValuesPipe implements PipeTransform {

  transform(value: UntypedFormGroup): unknown {
    return Object.values(value.getRawValue());
  }

}
